module.exports = __webpack_public_path__ + "res/32-img_game_top_bg_l.e3598ef2447cdefaf3abcabd83310d36.png";